import {
  addReserveProjectTypeApi,
  deleteReserveProjectTypeApi,
  updateReserveProjectTypeApi,
  getReserveProjectTypeListApi,
  addReserveProjectTagApi,
  deleteReserveProjectTagApi,
  updateReserveProjectTagApi,
  getReserveProjectTagListApi,
  queryReserveProjectTagApi,
  addReserveProjectApi,
  updateReserveProjectApi,
  setReserveProjectStateApi,
  queryReserveProjectListApi,
  getReserveProjectByIdApi,
  queryReserveStatisticsApi,
  queryReserveStatisticsDetailApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加预约项目类型信息
  async addReserveProjectTypeAction(context, param) {
    const res = await addReserveProjectTypeApi(param)
    return res
  },
  //  删除预约项目类型信息
  async deleteReserveProjectTypeAction(context, param) {
    const res = await deleteReserveProjectTypeApi(param)
    return res
  },
  //  修改预约项目类型信息
  async updateReserveProjectTypeAction(context, param) {
    const res = await updateReserveProjectTypeApi(param)
    return res
  },
  //  获取预约项目类型列表信息
  async getReserveProjectTypeListAction(context, param) {
    const res = await getReserveProjectTypeListApi(param)
    return res
  },
  //  添加预约项目标签信息
  async addReserveProjectTagAction(context, param) {
    const res = await addReserveProjectTagApi(param)
    return res
  },
  //  删除预约项目标签信息
  async deleteReserveProjectTagAction(context, param) {
    const res = await deleteReserveProjectTagApi(param)
    return res
  },
  //  修改预约项目标签信息
  async updateReserveProjectTagAction(context, param) {
    const res = await updateReserveProjectTagApi(param)
    return res
  },
  //  获取预约项目标签列表信息
  async getReserveProjectTagListAction(context, param) {
    const res = await getReserveProjectTagListApi(param)
    return res
  },
  //  查询预约项目标签列表信息
  async queryReserveProjectTagAction(context, param) {
    const res = await queryReserveProjectTagApi(param)
    return res
  },
  //  添加预约项目
  async addReserveProjectAction(context, param) {
    const res = await addReserveProjectApi(param)
    return res
  },
  //  修改预约项目
  async updateReserveProjectAction(context, param) {
    const res = await updateReserveProjectApi(param)
    return res
  },
  //  设置预约项目状态
  async setReserveProjectStateAction(context, param) {
    const res = await setReserveProjectStateApi(param)
    return res
  },
  //  查询预约项目列表
  async queryReserveProjectListAction(context, param) {
    const res = await queryReserveProjectListApi(param)
    return res
  },
  //  根据id查询预约项目
  async getReserveProjectByIdAction(context, param) {
    const res = await getReserveProjectByIdApi(param)
    return res
  },
  //  查询预约统计
  async queryReserveStatisticsAction(context, param) {
    const res = await queryReserveStatisticsApi(param)
    return res
  },
  //  查询预约统计详情
  async queryReserveStatisticsDetailAction(context, param) {
    const res = await queryReserveStatisticsDetailApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
